import * as Api from '@/utils/request'
import * as Api_jf from '../../utils/requestUri';

export default {
	async getUserInfo() {
        return await Api_jf.get({
            url: '/H5ReactUserCenter/index'
        }) 
    },
    
 
    //获取分享的数据
    async getShare(params){
        return await Api.get({
            url:'/H5/replica_details_share',
            params
        })
    },
}